import React from "react"
import { Link,Outlet } from "react-router-dom"
import "./communicate.css"
export default function HotelOwnerCommunicate(){

    return (
        <div>
            <div className=" flex flex-row space-x-2 landing-page">
                <Link to="farmers">farmers</Link>
                <Link to="customers">customers</Link>
                <Link to="admins">admins</Link>
            </div>
            <Outlet/>
        </div>
    )
}
